// This will need to keep in sync with the `ReactCSSTransitionGroupChild` `TICK` const.
// https://github.com/facebook/react/blob/master/src/addons/transitions/ReactCSSTransitionGroupChild.js#L22

export default 17;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-md/es/constants/CSSTransitionGroupTick.js
// module id = 17
// module chunks = 0